import React from 'react';
import styled from 'styled-components';
import illustrasiKanggo from '../../../assets/img/illustrasi-kanggo-warning.png';
import Dialog from '../../../components/Dialog';
import { Button } from '../../../components/Styled';

const DeleteImageWrapper = styled.div`
    position: relative;
    display: block;
    height: 140px;
    text-align: center;

    img {
        height: 100%;
    }
`;

interface IDialogDeleteTransaction {
    onDeleteConfirm: () => void,
    // eslint-disable-next-line no-unused-vars
    dialogHandler: (showDialog: boolean) => void
}

const DialogDeleteTransaction: React.FC<IDialogDeleteTransaction> = (props) => {
    const { onDeleteConfirm, dialogHandler } = props;

    const onConfirm = () => {
        onDeleteConfirm();
        dialogHandler(false);
    };

    return (
        <Dialog noWrap>
            <DeleteImageWrapper>
                <img src={illustrasiKanggo} alt="PT. Tenaga Kanggo Indonesia" />
            </DeleteImageWrapper>
            <p className="font-bold text-center my-3">Hapus Seluruh Transaksi?</p>
            <p className="text-center mb-3">Seluruh transaksi pengajuan pembayaran akan dihapus. Silahkan tambah transaksi kembali jika ingin menggabungkan pembayaran.</p>
            <div className="row">
                <div className="col-6">
                    <Button block border rounded textBlack primary onClick={() => dialogHandler(false)}>Batalkan</Button>
                </div>
                <div className="col-6">
                    <Button block rounded gradient onClick={() => onConfirm()}>OK. Pulihkan</Button>
                </div>
            </div>
        </Dialog>
    );
};

export default DialogDeleteTransaction;
